import { DatesApi } from "../api/datesApi";
import { ServicesApi } from "../api/servicesApi";
import { OfflineDays, ServiceAvailabilityException, Service } from "../types/entities";
import { CustomException } from "../types/customException";
import { validateServices } from "../utils/filter";
import { setServicesInLocalStorage } from "../utils/serviceTranslations";

const getActiveServices = async (
	setActiveServices: (services: Service[]) => void
) => {
	try {
		const servicesApi = new ServicesApi();
		let response = await servicesApi.fetchActiveServices();

		let services = response.data;

		if (!services || response.statusCode === 204 || services.length === 0) {
			throw new CustomException("There's nothing to display", 204, "noContent");
		}

		const validatedServices = validateServices(services);
		services = validatedServices;

		services = services.map((service) => {
			return {
				...service,
				startDate: new Date(service.startDate) ?? service.startDate,
				endDate: service.endDate ? new Date(service.endDate) : null,
			};
		});

		setServicesInLocalStorage(services);

		setActiveServices(services);
	} catch (error) {
		throw error;
	}
};

const getDaysOffline = async (
	setOfflineDays: (offlineDays: OfflineDays[]) => void
) => {
	try {
		const datesApi = new DatesApi();
		const response = await datesApi.fetchDaysOffline();

		const mappedOfflineDays = response.data.map((offlineDay) => {
			return {
				...offlineDay,
				date: new Date(offlineDay.date) ?? offlineDay.date,
			};
		});
		setOfflineDays(mappedOfflineDays);
	} catch (error) {
		throw Error(error);
	}
};

const getServicesDaysOffline = async (
	setServiceAvailabilityException: (ServiceAvailabilityException: ServiceAvailabilityException[]) => void
) => {
	try {
		const datesApi = new DatesApi();
		const response = await datesApi.fetchServicesDaysOffline();

		const mappedServiceAvailabilityException = response.data.map(
			(offlineServicesDay) => {
				return {
					...offlineServicesDay,
					date: new Date(offlineServicesDay.date) ?? offlineServicesDay.date,
				};
			}
		);
		setServiceAvailabilityException(mappedServiceAvailabilityException);
	} catch (error) {
		throw Error(error);
	}
};

export { getActiveServices, getDaysOffline, getServicesDaysOffline };
